module.exports = __webpack_public_path__ + "static/media/IMG_9516.146dc9b0.JPG";